import { useEffect, useMemo, useRef, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import GetAttributeDefinition, { AttributeDefinition, AttributeInputType, AttributeTargetType, GetComponentOrStyleValueFromDefinition, GetWBComponentByTypename } from "../Data/WBData";
import React from "react";
import { SiteData } from "../Data/SiteData";
import SelectDropdown from "../SelectDropdown";
import { GetLinearPageOptions, GetLinearPageOptionsWithParams, PageOptionParams } from "../Menus/PageSelectMenu";
import { GetLinkAndType, LinkTypeSeperator, LinkTypes } from "vagaro-website-rendering/src/components/Definitions/LinkData";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import CustomMultiSelect from "vagaro-website-rendering/src/components/CustomMultiSelect";
import MultiLocationField from "./MultiLocationField";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { GetBusinessClassCategories, GetBusinessFormList, GetBusinessMemberships, GetBusinessPackages, GetBusinessServices, GetPromoCodes, getDailyDeals } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import GetFormattedPhoneNumber, { GetPhoneNumberLength } from "../Utilities/PhoneUtils";
import { VagaroIcon } from "vagaro-website-rendering/src/components/Icons/SocialIcons";
import { Site } from "vagaro-website-rendering/src/utils/Utils";
import ButtonField from "./ButtonsField";


const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const urlValidation = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;


const isBDataLink = (linkType:string)=>{

  return linkType == LinkTypes.PromoCode||linkType == LinkTypes.DailyDeal||linkType == LinkTypes.Form||linkType == LinkTypes.Service||linkType == LinkTypes.Class||linkType == LinkTypes.Product||linkType == LinkTypes.Package||linkType == LinkTypes.Membership;


}


const staticList = ["none","dismiss"];
export default function LinkField({
  label,
  definition,
  layoutObject,
  updateFunc,
  saveFunc,
  screenSize,
  siteData,
}: AttributeFieldProps ) {


 const  intersectUpdate = (key:string,val:string,type:AttributeTargetType)=>{

    updateFunc(key,val,type);
    let n = layoutObject as LayoutNode;
    setTimeout(()=>{
    n.forceUpdate&&n.forceUpdate()},0);
 }


  let val = GetComponentOrStyleValueFromDefinition(
    definition,
    layoutObject,
    screenSize
  );



  let linkData = GetLinkAndType(val,LinkTypes.None);
   val = linkData.link;

   if(staticList.includes(val)){
    linkData.type = val;
   }

   if(linkData.type == LinkTypes.None){
    setNodeComponentAttributeValue(layoutObject,"isLink","");
   }
   else{
    setNodeComponentAttributeValue(layoutObject,"isLink","true");
   }

   /*
    For Navigation Bar and buttons, use multipage slection
    For container and image, use single page selection
    when type is Navigation Bar hide the scroll field
   */
  const useMultiPage = layoutObject.typename == wBComponentTypeNames.button || layoutObject.typename == wBComponentTypeNames.navigationBar;

  const canShowLinkBehavior = useMemo(()=>{

    let comp = GetWBComponentByTypename(layoutObject.typename);
    return(comp.editList.includes("linkOpenType"));

  },[layoutObject])

  const getSectionOptions = () => {

    let designer = siteData.designer;
    const returnList = [{label:"None",value:""}];
    if(designer){
      let layout = designer.state.layout;

      for(let i = 0;i<layout.children.length;i++){
        const node = layout.children[i];
        if(node.typename == wBComponentTypeNames.section||node.typename == wBComponentTypeNames.navigationBar||node.typename == wBComponentTypeNames.footer){

          let tag = getNodeComponentAttributeValue(node,"tag","");
          if(tag!=""){

            returnList.push({label:tag,value:node.id});
          }
          else if(node.typename == wBComponentTypeNames.section){
            returnList.push({label:"Section "+(i),value:node.id});
          }

        }

      }
    }

    return returnList;

  }

  if(linkData.type == LinkTypes.Page && useMultiPage){
    linkData.type = LinkTypes.MultiPage;
  }


  const [linkType,setLinkType] = useState(linkData.type);
  const urlRef = useRef<HTMLInputElement>(null);
  const changeLinkType = (newValue: string) => {


    //just save directly instead of updating link types if it's a static value that doesn't use a link def
    if(staticList.includes(newValue)){
      intersectUpdate(definition.attKey,newValue,definition.targetType);
      saveFunc();
      setLinkType(newValue);
      return;
    }

    if(linkType != newValue){
      intersectUpdate(definition.attKey, "", definition.targetType);
      if(urlRef.current){
        urlRef.current.value = "";
        intersectUpdate(definition.attKey, "", definition.targetType);
      }
      setNodeComponentAttributeValue(layoutObject,componentAttributeTypes.multiLocation,"");//reset location on each chane
      setNodeComponentAttributeValue(layoutObject,componentAttributeTypes.alloWMultiLocalationBooking,"");
      setLinkType(newValue);
      saveFunc();

      let node = layoutObject as LayoutNode;
      node.forceUpdate&&node.forceUpdate();
    }

  }


  if(layoutObject.typename === wBComponentTypeNames.navigationBar){
    const btnName = getNodeComponentAttributeValue(layoutObject,"buttonName","");
    if(btnName==""){
      return null;

    }

  }

  // else if(layoutObject.typename === wBComponentTypeNames.container||layoutObject.typename === wBComponentTypeNames.image ){
  //   if(getNodeComponentAttributeValue(layoutObject,"isLink","")!="true"){
  //     return null;
  //   }
  // }

  let params = new PageOptionParams();
  params.excludeDisabled = true;

  const pageOptions =  GetLinearPageOptionsWithParams(siteData,params);
  const multiOptions = GetLinearPageOptionsWithParams(siteData,params);

  pageOptions.splice(0,0,{label:"None",value:""});

  const options:{label:string,value:string,isAdvanced?:boolean}[] = [
    {label:"None",value:""},



]

if(layoutObject.typename == wBComponentTypeNames.popup){

  options.unshift({label:"Dismiss Pop-Up",value:"dismiss"});




}

if(useMultiPage){
  options.push({label:"Page",value:LinkTypes.MultiPage});
 }
 else{
  options.push({label:"Page",value:LinkTypes.Page});
 }

 options.push({label:"URL",value:LinkTypes.Url}); // insert AFTER page option

  if(layoutObject.typename !== wBComponentTypeNames.navigationBar){
    if(layoutObject.typename == wBComponentTypeNames.announcementBar || layoutObject.typename == wBComponentTypeNames.popup){
      options.push({label:"Daily Deal",value:LinkTypes.DailyDeal})

      if(layoutObject.typename!=wBComponentTypeNames.popup|| definition.attribute=="pop-completion-link")
      options.push({label:"Promo Code",value:LinkTypes.PromoCode})

    }
    options.push({label:"Form",value:LinkTypes.Form});

    if(layoutObject.typename!=wBComponentTypeNames.popup|| definition.attribute!="pop-completion-link" ){
    options.push( {label:"Email",value:LinkTypes.Email});
    options.push({label:"Phone",value:LinkTypes.Phone});
    }


  }
  else{ // keep email and phone for navigation bar
    options.push( {label:"Email",value:LinkTypes.Email});
    options.push({label:"Phone",value:LinkTypes.Phone});
  }

  if(layoutObject.typename != wBComponentTypeNames.navigationBar&&layoutObject.typename!=wBComponentTypeNames.announcementBar&&layoutObject.typename!=wBComponentTypeNames.popup){
   options.push({label:"Scroll To",value:LinkTypes.Scroll});

  }

  if(layoutObject.typename !== wBComponentTypeNames.navigationBar&&layoutObject.typename!=wBComponentTypeNames.announcementBar&&layoutObject.typename!=wBComponentTypeNames.popup){
    options.push({label:"Book a Service",value:LinkTypes.Service,isAdvanced:true});
    options.push({label:"Book a Class",value:LinkTypes.Class,isAdvanced:true});
    options.push({label:"Buy Package",value:LinkTypes.Package,isAdvanced:true});
    options.push({label:"Buy Membership",value:LinkTypes.Membership,isAdvanced:true});
  }


  let multiPages:string[] =[];
  if(linkType == LinkTypes.MultiPage){
    multiPages = val.split(",");

  }


  //removed invalid pages
  for(let i = 0;i<multiPages.length;i++){

    let pages = GetLinearPageOptions(siteData,false,false);

    let found  = false;

    for(let e= 0;e<pages.length;e++){
      if(pages[e].value == multiPages[i]){
        found = true;
        break;
      }
    }

    if(!found){
      multiPages.splice(i,1);
      i--;
    }

  }



  let placeHolder = "https://";
  if(linkType == LinkTypes.Email){
    placeHolder = "someone@example.com";
  }
  else if(linkType == LinkTypes.Phone){
    placeHolder = "";
  }


  let warning = "";


    let obj = layoutObject as LayoutNode;
    let parent = obj.parent;

    while(parent && linkData.type!=LinkTypes.None){
      if(parent.typename == wBComponentTypeNames.container){
        if(parent.componentAttributes["isLink"]==="true")
        warning = "Links inside linked containers will not function.";
        break;
      }
      parent = parent.parent;
    }




  const validateInput = (e:any,regex:RegExp,message:string)=>{
    e.target.value = e.target.value.replaceAll(" ","");

    if(!regex.test(e.target.value)){



      let validLine =  e.target.parentElement?.querySelector("#invalid-message");

      let parentClass = e.target.parentElement.parentElement;

      if(validLine){
        if(e.target.value.length>0){
          (validLine as HTMLElement).style.display = "block";
          parentClass.classList.add("invalid");
          (validLine as HTMLElement).innerText = message;
          return false;
        }
        else{
          parentClass.classList.remove("invalid");
          (validLine as HTMLElement).style.display = "none";
        }
      }



    }
    else{

      let validLine =  e.target.parentElement?.querySelector("#invalid-message");
      let parentClass = e.target.parentElement.parentElement;
      if(validLine){
        parentClass.classList.remove("invalid");
        (validLine as HTMLElement).style.display = "none";
      }
    }
    return true;

  }

  return (
    <>
    {(linkType == LinkTypes.Service||linkType == LinkTypes.Class) &&
      <style>
        {`
        .wb-input-group.linkopentype {display:none !important;}
        `
        }
      </style>
    }
      <div className="wb-input-group single-line no-border close-margin">

        <label>{label}</label>

      <SelectDropdown key={"dropdown-"+layoutObject.id} options={options} defaultValue={linkType} onChange={changeLinkType } />

      </div>
      {linkType == LinkTypes.Page && (


        <div className="wb-input-group single-line no-border">
          <label>Select Page:</label>
                 <SelectDropdown  key={"dropdown-page-"+layoutObject.id} options={pageOptions} defaultValue={val} onChange={(newVal:string)=>{


                  if(newVal.length>0){

                    let split = val.split(",");

                    newVal = (split.length>1)?
                    split[0]+LinkTypeSeperator+LinkTypes.Page+LinkTypeSeperator+split[1]:
                    newVal+LinkTypeSeperator+LinkTypes.Page;


                  }


                  intersectUpdate(definition.attKey,
                  newVal,
                  definition.targetType)
                  saveFunc();
                }}

                  />
        </div>
      )}

      {linkType == LinkTypes.Scroll && (


      <div className="wb-input-group single-line no-border">
        <label>Select Section:</label>
              <SelectDropdown key={"dropdown-scroll-to"+layoutObject.id}  options={getSectionOptions()} defaultValue={val} onChange={(newVal:string)=>{

                intersectUpdate(definition.attKey
                ,newVal+LinkTypeSeperator+LinkTypes.Scroll,
                definition.targetType);
                saveFunc();
                }} />
      </div>
      )}

      {linkType == LinkTypes.MultiPage && (


      <div className="wb-input-group single-line no-border">
        <label>{"Page"}</label>
              <div className="w-full inline-multi-select" style={{marginLeft:"12px"}}><CustomMultiSelect key={"dropdown-scroll-to" + layoutObject.id} placeholder="None" options={multiOptions} defaultValues={multiPages} onChange={(newVals: string[]) => {

                  let str = newVals.toString() + LinkTypeSeperator + LinkTypes.MultiPage;

                  intersectUpdate(definition.attKey,
                    str,
                    definition.targetType);
                  saveFunc();
                } } startOpen={false} footer={undefined}  /></div>
      </div>
      )}

      {(linkType == LinkTypes.Url||linkType == LinkTypes.Email||linkType==LinkTypes.Phone) && (
        <div className="wb-input-group no-border">
          <div className="wb-input-row">
          <div id="invalid-message" style={{display:"none", color:"red",marginLeft:"8px",fontSize:"12px",position:"absolute",top:"64px",left:"-6px"}}>Please enter a valid email address </div>
            <input
              type={"text"}
              key={linkType}
              maxLength={(linkType === LinkTypes.Phone)?GetPhoneNumberLength(siteData.userContext.countryCode??0,true):1000}
              ref={urlRef}
              autoComplete="off"
              placeholder={placeHolder}
              defaultValue={(linkType==LinkTypes.Phone)?GetFormattedPhoneNumber(val,siteData.userContext.countryCode??0,true):val}
              onChange={(e) => {

                if(linkType == LinkTypes.Email){
                  if(!validateInput(e,emailValidation,"Invalid Email")) return;
                }
                else if(linkType == LinkTypes.Url){
                  if(e.target.value.startsWith("www.")){
                    e.target.value = "https://"+e.target.value;
                  }

                  let message = "Invalid URL";


                  if(!validateInput(e,urlValidation,message)) return;
                }


                let val = e.target.value;
                if(linkType == LinkTypes.Phone){
                  let nums = e.target.value.replace(/[^0-9]/g, '');
                  let formated = GetFormattedPhoneNumber(nums,siteData.userContext.countryCode??0,true);
                  e.target.value = formated??"";
                  val = nums;
                }


                if(val){ // remove html tags
                  val = val.replaceAll("<","").replaceAll(">","").replaceAll(" ","");
                }

                if(linkType!=LinkTypes.Url){
                  val = val+LinkTypeSeperator+linkType;
                }


                intersectUpdate(
                  definition.attKey,
                  val,
                  definition.targetType
                );
                saveFunc();
              }}
            />

          </div>



        </div>
      )}
    {warning!=""&&<div style={{position:"static",marginTop:"-2px",background:"#f6d8d6",borderRadius:"4px",padding:"8px 16px"}} className="input-description flex-row gap-large" >
    {warning}</div>}

    {linkType==LinkTypes.None&& // need extra space at bottom when no secondary item shown
  <div style={{height:"16px"}}></div>

   }
    {isBDataLink(linkType) && <BusinessDataSelector inVal={val} key={linkType+"selection"} siteData={siteData} onSelect={(val:string)=>{

        let newVal = val+ (`${val}`.length>0?LinkTypeSeperator+linkType:"");
        intersectUpdate(definition.attKey,
        newVal,
        definition.targetType);

    }} definition={definition} layoutObject={layoutObject} linkType={linkType} />}

    <div style={{transition:".3s",overflow:"hidden",maxHeight:linkType!=LinkTypes.None?"112px":"0px",height:(linkType!=LinkTypes.None)?"auto":"100px"}}>


    {canShowLinkBehavior && linkType!=LinkTypes.None&&(linkType===LinkTypes.MultiPage||linkType===LinkTypes.Page||linkType===LinkTypes.Url)&&

    <ButtonField label ={"Link Behavior"} definition={GetAttributeDefinition("linkOpenType")} layoutObject={layoutObject} updateFunc={intersectUpdate} saveFunc={saveFunc} screenSize={ScreenSize.Desktop} siteData={siteData} extraClass=" no-top-space no-border"/>}
  </div>
  <div className="wb-input-group" style={{padding:0,margin:0,borderTop:"none"}}></div>
    </>
  );
}





function BusinessDataSelector({inVal,siteData,onSelect,layoutObject,definition,linkType}:{inVal:string,linkType:string,definition:AttributeDefinition, layoutObject:AttributeCollection,siteData:SiteData,onSelect:(val:string)=>void}){



  let loc = getNodeComponentAttributeValue(layoutObject,componentAttributeTypes.multiLocation,"");

  const [data,setData] = useState<any>(null);
  const [location,setLocation] = useState<string|null>(loc);


  const isMultiDef:AttributeDefinition = new AttributeDefinition(componentAttributeTypes.alloWMultiLocalationBooking,"Allow Booking At",componentAttributeTypes.alloWMultiLocalationBooking,AttributeInputType.ButtonField,[

    {label:"Selected Location",value:""},
    {label:"All Locations",value:"true"}

  ],null,AttributeTargetType.Component);



  const onChangeLocation = (val:string)=>{

    setNodeComponentAttributeValue(layoutObject,componentAttributeTypes.multiLocation,val);
    onSelect("");
    if(val!=location){
    setLocation(val);
    setData(null);
  }


  }


  useEffect(()=>{

    if(!data){
      setData("loading");
      let context = {...siteData.userContext};
      if(location){
        context.businessId = location;
      }



      switch(linkType){
        case LinkTypes.PromoCode:
              GetPromoCodes(context,(data:any)=>{
                setData(data)

              },(err:any)=>{setData("error")});

            break;
        case LinkTypes.DailyDeal:

            getDailyDeals(context,(data:any)=>{

              if(!data){
                setData([]);
              }
              else{
                if(!data.dailyDealList){
                  data.dailyDealList = [];
                }
                  setData(data.dailyDealList)
              }

            },(err:any)=>{setData("error");});
            break;
        case LinkTypes.Form:
            GetBusinessFormList(context,context.businessId,(data:any)=>{
              if(!data){
                setData([]);
              }
              else{

                  setData(data)
              }

            }
            );
            break;
        case LinkTypes.Service:
            GetBusinessServices(context,(data:any)=>{
              if(!data){
                setData([]);
              }
              else{

                  setData(data)
              }

            }
            );
            break;
        case LinkTypes.Class:
          GetBusinessClassCategories(context,context.businessId,(data:any)=>{
            if(!data){
              setData([]);
            }
            else{

                setData(data)
            }

          }
          );
          break;
        case LinkTypes.Package:

        GetBusinessPackages(context,(data:any)=>{

            if(!data||data.length == 0||!data[0].packageList){
              setData([]);
            }
            else{
                setData(data[0].packageList)
            }

          }
          );
          break;
        case LinkTypes.Membership:
          GetBusinessMemberships(context,(data:any)=>{

            if(!data||data.length == 0||!data[0].membershipList){
              setData([]);
            }
            else{
                setData(data[0].membershipList)
            }

          }
          );
          break;

          default:
          setData([]);
      }






    }
  // eslint-disable-next-line
  },[location])



  let options: {label:string,value:string,isDivider?:boolean}[] = [{ label: "None", value: "" }];



  if(data!=null){
    switch(linkType){

      case LinkTypes.PromoCode:
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].code, value: data[i].code });
          }
        } else {
          options = [{ label: "No Promotions Available", value: "" }];
        }
        break;
      case LinkTypes.DailyDeal:
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].promotionTitle, value: data[i].dailyDealURL });
          }
        } else {
          options = [{ label: "No Daily Deals Available ", value: "" }];
        }
        break;
      case LinkTypes.Form:
        const baseURL =  "https://forms.vagaro.com/";


        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].name, value:baseURL+ data[i].formId });
          }
        } else {
          options = [{ label: "No Forms Available ", value: "" }];
        }
        break;
      case LinkTypes.Service:
        let mainData = data[0];

        if(mainData){

        let catList = mainData.serviceCategoryList;

        if(catList)
        for(let i = 0;i<catList.length;i++){
          options.push({label:catList[i].serviceCategoryName,value:"",isDivider:true});
          let services = catList[i].serviceList;

          for(let e = 0;e<services.length;e++){
            options.push({label:services[e].serviceTitle,value:services[e].hashServiceId});
          }


        }

      }
       if(options.length == 0) {
          options = [{ label: "No Services Available ", value: "" }];
        }

        break;
      case LinkTypes.Class:
        for(let i = 0;i<data.length;i++){
          let d = data[i];

          if(d){
            options.push({label:d.CategoryName,value:"",isDivider:true});

          let classes = d.Services;

          if(classes)
          for(let e = 0;e<classes.length;e++){
            options.push({label:classes[e].classTitle,value:classes[e].classId});
          }
        }

      }
        if(options.length == 0) {
          options = [{ label: "No Services Available ", value: "" }];
        }
        break;
      case LinkTypes.Package:


          for(let i = 0;i<data.length;i++){
            let pkg = data[i];

            options.push({label:pkg.packageName,value:pkg.hashPackageId});
          }


        break;
      case LinkTypes.Membership:


      for(let i = 0;i<data.length;i++){
        let mbr = data[i];

        options.push({label:mbr.membershipName,value:mbr.hashMembershipId});
      }
        break;

        default:
          break;


    }



  }

  const fadeStyle = {
   color:"#919191",
    fontWeight:500
  }


  let vLink = Site.SiteName??"https://www.vagaro.com";
  let vMessage = "Edit in Vagaro"

  if(linkType == LinkTypes.PromoCode){
    vLink +="/merchants/settings/discounts";
    vMessage = "Create a Promo Code"

  }
  else if(linkType == LinkTypes.DailyDeal){
    vLink += "/merchants/settings/deals";
    vMessage = "Create a Daily Deal"

  }
  else if(linkType == LinkTypes.Form){
    vLink += "/merchants/forms";
    vMessage = "Create a Form"
  }
  else if(linkType == LinkTypes.Service){
    vLink += "/ShopOwner/ManageNewServices.aspx";
    vMessage = "Manage Services"
  }  else if(linkType == LinkTypes.Class){
    vLink += "/ShopOwner/ManageNewServices.aspx";
    vMessage = "Manage Classes"
  }


  return (
    <>
      {
        <MultiLocationField
          definition={definition}
          siteData={siteData}
          label={"Promo Code"}
          screenSize={ScreenSize.Desktop}
          layoutObject={layoutObject}
          saveFunc={() => {}}
          updateFunc={(
            attKey: string,
            val: string,
            targetType: AttributeTargetType
          ) => {
            onChangeLocation(val);
          }}
        />
      }


      <div
        style={{
          background: "inherit",
          marginTop: "-18px",
          position: "relative",
        }}
      >

        {
          <div className={"wb-input-group single-line full-select " +(siteData.locations.length>1?"no-border":"")}>


            {data != null && data != "loading" && data != "error" && <>
              { options.length>1?
              <SelectDropdown
              allowFilter = {(linkType == LinkTypes.Service||linkType == LinkTypes.Class)}
              useExpanders = {(linkType == LinkTypes.Service||linkType == LinkTypes.Class)}
                footer = {
                  <div className="w-full gray-hover center-all">
                  <a href={vLink} rel="noreferrer" target="_blank" className="invisible-button center-all "  style={{color:"var(--input-selected-primary)",fontSize:"14px",textDecoration:"none",display:"block",padding:"12px",fontWeight:"normal"}}><span>{vMessage}</span>&nbsp;<VagaroIcon/></a>
                  </div>

                }
                options={options}
                defaultValue={inVal}
                onChange={(val: string) => {

                  let expDate = "";
                  if(linkType == LinkTypes.PromoCode){
                    //save promo code information
                    let obj = data.find((e:any)=>e.code == val);

                     expDate = obj?.endDate??"";

                  }
                  else if(linkType == LinkTypes.DailyDeal){
                    let obj = data.find((e:any)=>e.dailyDealURL == val);
                     expDate = obj.eDate??"";
                    //save daily deal information
                  }


                  setNodeComponentAttributeValue(layoutObject,"announcementExpiresAt",expDate);
                  onSelect(val);
                }}
              />:<div className="wb-input-row gray-hover"><a className="w-full  center-all gap-med no-link gray-hover" href={vLink} rel="noreferrer" target="_blank"  > {vMessage} <VagaroIcon/></a></div>

            }
            </>
            }
            {data == "loading" && <span style={fadeStyle} className="select-dropdown">{"Loading..."}</span>}
            {data == "error" &&   <span style = {fadeStyle} className="select-dropdown">{"Oops, please try again"}</span>}
            {!data && <span className="select-dropdown">{"Select a location"}</span>

            }
          </div>
        }

{
  siteData.locations.length>1&& (linkType==LinkTypes.Service||linkType == LinkTypes.Class)&&


  <ButtonField label={"Allow Booking at"} definition={isMultiDef} layoutObject={layoutObject} updateFunc={
    (
      attribute: string,
      value: string,
      targetType: AttributeTargetType)=>
    {
      setNodeComponentAttributeValue(layoutObject,componentAttributeTypes.alloWMultiLocalationBooking,value);

    }}
    screenSize={ScreenSize.Desktop} siteData={siteData} saveFunc={()=>{}} extraClass="p-0 no-border"/>
}
      </div>



    </>
  );










}
